import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  TextField,
  Grid,
  MenuItem,
  Typography,
  Divider,
  IconButton,
  Snackbar,
  Alert,
  LinearProgress,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import ShowRevaluationDialog from "./ShowRevaluationDialog";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
const RowActionMenu = ({
  row,
  onEdit,
  onDelete,
  onSOMDownload,
  somDownloading,
  pcDownloading,
  cmmDownloading,
  trDownloading,
  onProcessResult,
  onPublishResult,
  onValuationBill,
  onAnalyzeResult,
  onReleaseResult,
  onUnReleaseResult,
  onPCDownload,
  onCMMDownload,
  onTRDownload,
  onOpenRevaluationDialog,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const user = JSON.parse(sessionStorage.getItem("user"));
  const clientId = user?.client_id;
  const collegeId = user?.college_id;
  const handleOpen = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <IconButton size="medium" onClick={handleOpen}>
        <MoreVertIcon fontSize="small" />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={(e) => e.stopPropagation()}
      >
        {row.workflow_status === "DRAFT" ? (
          <>
            <MenuItem
              onClick={() => {
                onEdit(row);
                handleClose();
              }}
            >
              Edit
            </MenuItem>

            <MenuItem
              onClick={() => {
                onDelete(row.valuation_schedule_master_id);
                handleClose();
              }}
              sx={{ color: "error.main" }}
            >
              Delete
            </MenuItem>
          </>
        ) : (
          <>
            {["REVALUATION", "CHALLENGE"].includes(row.valuation_type) && (
              <MenuItem
                onClick={() => {
                  handleClose();
                  // Debug log before opening dialog

                  // Fetch year and semester before opening dialog
                  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
                  axios
                    .get(`${API_BASE_URL}/api/exam-external-schedule-details/year-semester`, {
                      params: {
                        exam_schedule_master_id: row.exam_schedule_master_id,
                        college_id: row.college_id,
                        client_id: clientId,
                      },
                    })
                    .then((res) => {
                      if (res.data && res.data.success) {
                        const { year_number, semester_number } = res.data;

                        onOpenRevaluationDialog({
                          ...row,
                          year_number,
                          semester_number,
                        });
                      } else {
                        alert("Could not fetch year/semester for revaluation.");
                      }
                    })
                    .catch(() => {
                      alert("Error fetching year/semester for revaluation.");
                    });
                }}
              >
                Allot Revaluation Scripts
              </MenuItem>
            )}
            <MenuItem
              onClick={() => {
                onValuationBill(row);
                handleClose();
              }}
            >
              Valuation Bill
            </MenuItem>

            <MenuItem
              onClick={() => {
                onProcessResult(row);
                handleClose();
              }}
            >
              Process Result
            </MenuItem>
            <MenuItem
              onClick={() => {
                onPublishResult(row);
                handleClose();
              }}
            >
              Publish Result
            </MenuItem>
            <MenuItem
              onClick={() => {
                onAnalyzeResult(row);
                handleClose();
              }}
            >
              Result Analysis
            </MenuItem>
            <MenuItem
              onClick={() => {
                onReleaseResult(row);
                handleClose();
              }}
            >
              Release Result
            </MenuItem>
            <MenuItem
              onClick={() => {
                onUnReleaseResult(row);
                handleClose();
              }}
            >
              UnRelease Result
            </MenuItem>

            <MenuItem
              disabled={somDownloading}
              onClick={() => {
                handleClose();
                onSOMDownload(row);
              }}
            >
              {somDownloading ? "Generating SOM..." : "SOM"}
            </MenuItem>
            <MenuItem
              disabled={pcDownloading}
              onClick={() => {
                handleClose();
                onPCDownload(row);
              }}
            >
              {pcDownloading ? "Generating PC..." : "PC"}
            </MenuItem>
            <MenuItem
              disabled={cmmDownloading}
              onClick={() => {
                handleClose();
                onCMMDownload(row);
              }}
            >
              {cmmDownloading ? "Generating CMM..." : "CMM"}
            </MenuItem>
            <MenuItem
              disabled={trDownloading}
              onClick={() => {
                handleClose();
                onTRDownload(row);
              }}
            >
              {trDownloading ? "Generating TR..." : "TR"}
            </MenuItem>
          </>
        )}
      </Menu>
    </>
  );
};
RowActionMenu.propTypes = {
  row: PropTypes.shape({
    workflow_status: PropTypes.string.isRequired,
    valuation_schedule_master_id: PropTypes.number.isRequired,
    exam_schedule_master_id: PropTypes.number, // ✅ ADD THIS
    college_id: PropTypes.number,
    valuation_type: PropTypes.string,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onSOMDownload: PropTypes.func.isRequired,
  somDownloading: PropTypes.bool.isRequired,
  pcDownloading: PropTypes.bool.isRequired,
  cmmDownloading: PropTypes.bool.isRequired,
  trDownloading: PropTypes.bool.isRequired,
  onProcessResult: PropTypes.func.isRequired,
  onPublishResult: PropTypes.func.isRequired,
  onAnalyzeResult: PropTypes.func.isRequired,
  onValuationBill: PropTypes.func.isRequired,
  onReleaseResult: PropTypes.func.isRequired,
  onUnReleaseResult: PropTypes.func.isRequired,
  onPCDownload: PropTypes.func.isRequired,
  onCMMDownload: PropTypes.func.isRequired,
  onTRDownload: PropTypes.func.isRequired,
  onOpenRevaluationDialog: PropTypes.func.isRequired,
};
const ValuationScheduleDialog = ({
  row,
  open,
  onClose,
  examScheduleMasterId,
  examDate,
  programId,
  branchId,
  showSnackbar,
}) => {
  const [scheduleDetails, setScheduleDetails] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [processing, setProcessing] = useState(false);
  const [somDownloading, setSomDownloading] = useState(false);
  const [pcDownloading, setPCDownloading] = useState(false);
  const [cmmDownloading, setCMMDownloading] = useState(false);
  const [trDownloading, setTRDownloading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [revaluationDialogOpen, setRevaluationDialogOpen] = useState(false);

  const [selectedRevaluationRow, setSelectedRevaluationRow] = useState(null);
  const [form, setForm] = useState({
    college_id: row.college_id || "",
    exam_schedule_master_id: row.exam_schedule_master_id || "",
    valuation_type: "NORMAL",
    revaluation_round: 0,
    valuation_pattern_id: "",
    fee_amount: "",
    fee_head_id: "",
    valuation_from_date: "",
    valuation_to_date: "",
    bundle_no_from: "",
    bundle_no_to: "",
    script_allot_size: "",
    workflow_status: "DRAFT",
  });
  const [editId, setEditId] = useState(null); // track edited row
  const [showRevaluationDialog, setShowRevaluationDialog] = useState({ open: false, row: null });

  // Expose dialog open function globally for RowActionMenu
  useEffect(() => {
    window.openRevaluationDialog = (clickedRow) => {
      const mergedRow = {
        ...row,
        ...clickedRow,
        semester_number: clickedRow.semester_number || row?.semester_number,
        year_number: clickedRow.year_number || row?.year_number,
      };

      setShowRevaluationDialog({
        open: true,
        row: mergedRow,
      });
    };
    return () => {
      window.openRevaluationDialog = undefined;
    };
  }, [row]);
  const user = JSON.parse(sessionStorage.getItem("user"));
  const clientId = user?.client_id;
  const collegeId = user?.college_id;

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const handleOpenRevaluationDialog = (rowData) => {
    setSelectedRevaluationRow(rowData);
    setRevaluationDialogOpen(true);
  };

  const handleCloseRevaluationDialog = () => {
    setRevaluationDialogOpen(false);
    setSelectedRevaluationRow(null);
  };
  const fetchScheduleDetails = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/api/valuation-schedule/${clientId}/${collegeId}/${row.exam_schedule_master_id}`
      );
      setScheduleDetails(res.data || []);
    } catch (err) {
      console.error("Error fetching schedules:", err);
    }
  };

  useEffect(() => {
    if (open) fetchScheduleDetails();
  }, [open]);

  const handleClose = () => {
    onClose();
    setEditId(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleAddOrUpdateSchedule = async () => {
    try {
      const payload = {
        ...form,
        revaluation_round: Number(form.revaluation_round),
        valuation_pattern_id: form.valuation_pattern_id ? Number(form.valuation_pattern_id) : null,
        bundle_no_from: form.bundle_no_from ? Number(form.bundle_no_from) : null,
        bundle_no_to: form.bundle_no_to ? Number(form.bundle_no_to) : null,
        script_allot_size: form.script_allot_size ? Number(form.script_allot_size) : null,
      };

      if (editId) {
        // Update existing
        await axios.put(
          `${API_BASE_URL}/api/valuation-schedule/${clientId}/${collegeId}/${examScheduleMasterId}/${editId}`,
          payload
        );
        alert("Valuation schedule updated successfully!");
      } else {
        // Add new
        await axios.post(
          `${API_BASE_URL}/api/valuation-schedule/${clientId}/${collegeId}/${examScheduleMasterId}`,
          payload
        );
        alert("New valuation schedule added successfully!");
      }

      setForm({
        college_id: row.college_id || "",
        exam_schedule_master_id: row.exam_schedule_master_id || "",
        valuation_type: "NORMAL",
        revaluation_round: 0,
        valuation_pattern_id: "",
        fee_amount: "",
        valuation_from_date: "",
        valuation_to_date: "",
        bundle_no_from: "",
        bundle_no_to: "",
        script_allot_size: "",
        workflow_status: "DRAFT",
      });

      setEditId(null);
      fetchScheduleDetails();
    } catch (err) {
      console.error("Error adding/updating schedule:", err);
      alert("Failed to save schedule!");
    }
  };

  const handleEdit = (row) => {
    setEditId(row.valuation_schedule_master_id);
    setForm({
      college_id: row.college_id,
      exam_schedule_master_id: row.exam_schedule_master_id,
      valuation_type: row.valuation_type,
      revaluation_round: row.revaluation_round,
      valuation_pattern_id: row.valuation_pattern_id || "",
      fee_amount: row.fee_amount,
      valuation_from_date: row.valuation_from_date,
      valuation_to_date: row.valuation_to_date,
      bundle_no_from: row.bundle_no_from,
      bundle_no_to: row.bundle_no_to,
      script_allot_size: row.script_allot_size,
      workflow_status: row.workflow_status,
    });
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this schedule?")) return;

    try {
      await axios.delete(
        `${API_BASE_URL}/api/valuation-schedule/${clientId}/${collegeId}/${examScheduleMasterId}/${id}`
      );
      alert("Valuation schedule deleted successfully!");
      fetchScheduleDetails();
    } catch (err) {
      console.error("Error deleting schedule:", err);
      alert("Failed to delete schedule!");
    }
  };

  const handleSOMDownload = async (scheduleRow) => {
    try {
      setSomDownloading(true);
      const response = await axios.get(`${API_BASE_URL}/api/som/download`, {
        params: {
          valuation_schedule_master_id: scheduleRow.valuation_schedule_master_id,
          client_id: clientId,
        },
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `Semester_Marks_Sheet_${scheduleRow.valuation_schedule_master_id}.pdf`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      setSnackbar({
        open: true,
        message: "SOM PDF downloaded successfully",
        severity: "success",
      });
    } catch (err) {
      console.error("SOM download error:", err);
      const message = await getBlobErrorMessage(err, "Failed to download SOM PDF");
      setSnackbar({
        open: true,
        message,
        severity: "error",
      });
    } finally {
      setSomDownloading(false);
    }
  };

  const getBlobErrorMessage = async (err, fallback) => {
    const responseData = err?.response?.data;
    if (responseData instanceof Blob) {
      try {
        const text = await responseData.text();
        const parsed = JSON.parse(text);
        return parsed?.message || parsed?.details || fallback;
      } catch {
        return fallback;
      }
    }

    return err?.response?.data?.message || err?.response?.data?.details || fallback;
  };

  const handlePCDownload = async (scheduleRow) => {
    try {
      setPCDownloading(true);
      const response = await axios.get(`${API_BASE_URL}/api/pc/download`, {
        params: {
          valuation_schedule_master_id: scheduleRow.valuation_schedule_master_id,
          client_id: clientId,
        },
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `PC_${scheduleRow.valuation_schedule_master_id}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      setSnackbar({
        open: true,
        message: "PC PDF downloaded successfully",
        severity: "success",
      });
    } catch (err) {
      console.error("PC download error:", err);
      const message = await getBlobErrorMessage(err, "Failed to download PC PDF");
      setSnackbar({
        open: true,
        message,
        severity: "error",
      });
    } finally {
      setPCDownloading(false);
    }
  };

  const handleCMMDownload = async (scheduleRow) => {
    try {
      setCMMDownloading(true);
      const response = await axios.get(`${API_BASE_URL}/api/cmm/download`, {
        params: {
          valuation_schedule_master_id: scheduleRow.valuation_schedule_master_id,
          client_id: clientId,
        },
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `CMM_${scheduleRow.valuation_schedule_master_id}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      setSnackbar({
        open: true,
        message: "CMM PDF downloaded successfully",
        severity: "success",
      });
    } catch (err) {
      console.error("CMM download error:", err);
      const message = await getBlobErrorMessage(err, "Failed to download CMM PDF");
      setSnackbar({
        open: true,
        message,
        severity: "error",
      });
    } finally {
      setCMMDownloading(false);
    }
  };

  const handleTRDownload = async (scheduleRow) => {
    try {
      setTRDownloading(true);
      const response = await axios.get(`${API_BASE_URL}/api/tr/download`, {
        params: {
          valuation_schedule_master_id: scheduleRow.valuation_schedule_master_id,
          client_id: clientId,
        },
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `TR_${scheduleRow.valuation_schedule_master_id}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      setSnackbar({
        open: true,
        message: "TR PDF downloaded successfully",
        severity: "success",
      });
    } catch (err) {
      console.error("TR download error:", err);
      const message = await getBlobErrorMessage(err, "Failed to download TR PDF");
      setSnackbar({
        open: true,
        message,
        severity: "error",
      });
    } finally {
      setTRDownloading(false);
    }
  };

  const handleProcessResult = async (row) => {
    if (!window.confirm("Are you sure you want to process the result?")) return;
    let url = null;
    if (row.valuation_type === "NORMAL" && Number(row.revaluation_round) === 0) {
      url = `${API_BASE_URL}/api/process-result/${clientId}/${collegeId}/${examScheduleMasterId}/${row.valuation_schedule_master_id}`;
    } else {
      url = `${API_BASE_URL}/api/process-reval-result/${clientId}/${collegeId}/${examScheduleMasterId}/${row.valuation_schedule_master_id}`;
    }
    try {
      setProcessing(true);
      const response = await axios.post(
        url,
        {},
        {
          responseType: "blob",
          headers: {
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            "If-Modified-Since": "0",
          },
        }
      );

      const fileName = `Result_${examScheduleMasterId}.pdf`;

      const blobUrl = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );

      window.open(blobUrl, "_blank");

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(blobUrl);
      const message = "Result processed & PDF generated successfully!";
      setSnackbar({
        open: true,
        message,
        severity: "success",
      });
      //alert("Result processed & PDF generated successfully!");
      fetchScheduleDetails();
    } catch (err) {
      console.error("Error processing result:", err);
      //alert(err?.response?.data?.message || "Failed to process result!");
      const message = "Failed to process result!";
      setSnackbar({
        open: true,
        message,
        severity: "error",
      });
    } finally {
      setProcessing(false);
    }
  };

  const handleAnalyzeResult = async (row) => {
    if (!window.confirm("Are you sure you want to process the result?")) return;

    const url = `${API_BASE_URL}/api/process-result/${clientId}/${collegeId}/${examScheduleMasterId}/${row.valuation_schedule_master_id}/analysis`;

    try {
      setProcessing(true);
      const response = await axios.post(
        url,
        {},
        {
          responseType: "blob",
          headers: {
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            "If-Modified-Since": "0",
          },
        }
      );

      const fileName = `Result_Analysis_${examScheduleMasterId}.pdf`;

      const blobUrl = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );

      window.open(blobUrl, "_blank");

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(blobUrl);

      //alert("Result processed & PDF generated successfully!");
      const message = "Result analysis processed & PDF generated successfully!";
      setSnackbar({
        open: true,
        message,
        severity: "success",
      });
      fetchScheduleDetails();
    } catch (err) {
      console.error("Error processing result:", err);
      //alert(err?.response?.data?.message || "Failed to process result!");
      const message = "Failed to process result!";
      setSnackbar({
        open: true,
        message,
        severity: "error",
      });
    } finally {
      setProcessing(false);
    }
  };

  const handleReleaseResult = async (row) => {
    if (!window.confirm("Are you sure you want to release the result?")) return;

    const url = `${API_BASE_URL}/api/process-result/${clientId}/${collegeId}/${examScheduleMasterId}/${row.valuation_schedule_master_id}/release`;

    try {
      setProcessing(true);
      const response = await axios.post(url, {});

      //alert(response?.data?.message || "Result released successfully!");
      const message = "Result released successfully!";
      setSnackbar({
        open: true,
        message,
        severity: "error",
      });
      fetchScheduleDetails();
    } catch (err) {
      console.error("Error releasing result:", err);
      // alert(err?.response?.data?.message || "Failed to release result!");
      const message = "Failed to release result!";
      setSnackbar({
        open: true,
        message,
        severity: "error",
      });
    } finally {
      setProcessing(false);
    }
  };

  const handleUnReleaseResult = async (row) => {
    if (!window.confirm("Are you sure you want to unrelease the result?")) return;

    const url = `${API_BASE_URL}/api/process-result/${clientId}/${collegeId}/${examScheduleMasterId}/${row.valuation_schedule_master_id}/unrelease`;

    try {
      setProcessing(true);
      const response = await axios.post(url, {});

      //alert(response?.data?.message || "Result unreleased successfully!");
      const message = "Result unreleased successfully!";
      setSnackbar({
        open: true,
        message,
        severity: "error",
      });
      fetchScheduleDetails();
    } catch (err) {
      console.error("Error unreleasing result:", err);
      //alert(err?.response?.data?.message || "Failed to unrelease result!");
      const message = "Failed to unrelease result!";
      setSnackbar({
        open: true,
        message,
        severity: "error",
      });
    } finally {
      setProcessing(false);
    }
  };

  const handlePublishResult = async (row) => {
    if (!window.confirm("Are you sure you want to publish the result?")) return;

    let url = null;
    if (row.valuation_type === "NORMAL" && Number(row.revaluation_round) === 0) {
      url = `${API_BASE_URL}/api/process-result/${clientId}/${collegeId}/${examScheduleMasterId}/${row.valuation_schedule_master_id}/publish`;
    } else {
      url = `${API_BASE_URL}/api/process-reval-result/${clientId}/${collegeId}/${examScheduleMasterId}/${row.valuation_schedule_master_id}/publish`;
    }

    try {
      setProcessing(true); // 🔥 START LOADING
      const response = await axios.post(
        url,
        {},
        {
          responseType: "blob", // 🔥 IMPORTANT
          headers: {
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            "If-Modified-Since": "0",
          },
        }
      );

      const fileName = `Publish_Result_${examScheduleMasterId}.pdf`;

      const blobUrl = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );

      // 🔹 Open in new tab
      window.open(blobUrl, "_blank");

      // 🔹 Optional auto-download
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(blobUrl);

      //alert("Result published & PDF generated successfully!");
      const message = "Result published & PDF generated successfully!";
      setSnackbar({
        open: true,
        message,
        severity: "success",
      });
      fetchScheduleDetails();
    } catch (err) {
      console.error("Error processing result:", err);
      //alert(err?.response?.data?.message || "Failed to publish result!");
      const message = "Failed to publish result!";
      setSnackbar({
        open: true,
        message,
        severity: "error",
      });
    } finally {
      setProcessing(false); // 🔥 STOP LOADING
    }
  };

  const handleValuationBill = async (row) => {
    if (!window.confirm("Are you sure you want to generates valuation bill?")) return;

    const url = `${API_BASE_URL}/api/process-result/valuation-bill/${clientId}/${collegeId}/${row.valuation_schedule_master_id}`;

    try {
      const response = await axios.post(
        url,
        {},
        {
          responseType: "blob", // 🔥 IMPORTANT
          headers: {
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            "If-Modified-Since": "0",
          },
        }
      );

      const fileName = `Valuation_Bills_${examScheduleMasterId}.pdf`;

      const blob = new Blob([response.data], {
        type: "application/pdf",
      });

      const blobUrl = window.URL.createObjectURL(blob);

      // Open PDF
      window.open(blobUrl, "_blank");

      // Download with correct filename
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();

      // Don't revoke immediately
      setTimeout(() => {
        window.URL.revokeObjectURL(blobUrl);
      }, 1000);
    } catch (err) {
      console.error("Error generating valuation bill:", err);

      const message = await getBlobErrorMessage(err, "Failed to generate valuation bill.");

      //   const message = "Failed to publish result!";
      alert(message);
    }

    const url2 = `${API_BASE_URL}/api/process-result/valuation-bill-course/${clientId}/${collegeId}/${row.valuation_schedule_master_id}`;

    try {
      const response = await axios.post(
        url2,
        {},
        {
          responseType: "blob", // 🔥 IMPORTANT
          headers: {
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            "If-Modified-Since": "0",
          },
        }
      );

      const fileName = `Valuation_Bills_CourseWise_${examScheduleMasterId}.pdf`;

      const blob = new Blob([response.data], {
        type: "application/pdf",
      });

      const blobUrl = window.URL.createObjectURL(blob);

      // Open PDF
      window.open(blobUrl, "_blank");

      // Download with correct filename
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();

      // Don't revoke immediately
      setTimeout(() => {
        window.URL.revokeObjectURL(blobUrl);
      }, 1000);

      fetchScheduleDetails();
    } catch (err) {
      console.error("Error generating valuation bill:", err);

      const message = await getBlobErrorMessage(err, "Failed to generate valuation bill.");

      alert(message);
    }

    const url3 = `${API_BASE_URL}/api/process-result/valuation-bill-scrutiny/${clientId}/${collegeId}/${row.valuation_schedule_master_id}`;

    try {
      const response = await axios.post(
        url3,
        {},
        {
          responseType: "blob", // 🔥 IMPORTANT
          headers: {
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            "If-Modified-Since": "0",
          },
        }
      );

      const fileName = `Valuation_Bills_Scrutiny_${examScheduleMasterId}.pdf`;

      const blob = new Blob([response.data], {
        type: "application/pdf",
      });

      const blobUrl = window.URL.createObjectURL(blob);

      // Open PDF
      window.open(blobUrl, "_blank");

      // Download with correct filename
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();

      // Don't revoke immediately
      setTimeout(() => {
        window.URL.revokeObjectURL(blobUrl);
      }, 1000);

      const message = "Valuation Bills & PDF generated successfully!";
      alert(message);
      fetchScheduleDetails();
    } catch (err) {
      console.error("Error generating valuation bill:", err);

      const message = await getBlobErrorMessage(err, "Failed to generate valuation bill.");

      alert(message);
    }
  };
  const columns = [
    { field: "valuation_schedule_master_id", headerName: "ID", width: 50 },
    { field: "valuation_type", headerName: "Type", width: 150 },
    { field: "revaluation_round", headerName: "Round", width: 90 },
    {
      field: "valuation_from_date",
      headerName: "Start Date",
      width: 120,
      valueFormatter: (params) => {
        const value = params.value;

        if (!value) return "";

        const date = new Date(value);
        return isNaN(date.getTime()) ? value : date.toLocaleDateString("en-GB");
      },
    },
    {
      field: "valuation_to_date",
      headerName: "End Date",
      width: 120,
      valueFormatter: (params) => {
        const value = params.value;

        if (!value) return "";

        const date = new Date(value);
        return isNaN(date.getTime()) ? value : date.toLocaleDateString("en-GB");
      },
    },
    { field: "workflow_status", headerName: "Status", width: 120 },
    {
      field: "actions",
      headerName: "Actions",
      width: 90,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <RowActionMenu
          row={params.row}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onSOMDownload={handleSOMDownload}
          somDownloading={somDownloading}
          pcDownloading={pcDownloading}
          cmmDownloading={cmmDownloading}
          trDownloading={trDownloading}
          onProcessResult={handleProcessResult}
          onPublishResult={handlePublishResult}
          onValuationBill={handleValuationBill}
          onAnalyzeResult={handleAnalyzeResult}
          onReleaseResult={handleReleaseResult}
          onUnReleaseResult={handleUnReleaseResult}
          onPCDownload={handlePCDownload}
          onCMMDownload={handleCMMDownload}
          onTRDownload={handleTRDownload}
          onOpenRevaluationDialog={handleOpenRevaluationDialog}
        />
      ),
    },
  ];

  let downloadStatusMessage = snackbar.message;
  if (somDownloading) {
    downloadStatusMessage = "Generating SOM PDF... Please wait";
  } else if (pcDownloading) {
    downloadStatusMessage = "Generating PC PDF... Please wait";
  } else if (cmmDownloading) {
    downloadStatusMessage = "Generating CMM PDF... Please wait";
  } else if (trDownloading) {
    downloadStatusMessage = "Generating TR PDF... Please wait";
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
          }

          handleClose();
        }}
        disableEscapeKeyDown
        maxWidth="md"
        PaperProps={{
          sx: {
            height: "70vh", // reduce height
          },
        }}
      >
        {(somDownloading || pcDownloading || cmmDownloading || trDownloading) && (
          <LinearProgress
            color="info"
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              zIndex: 2,
            }}
          />
        )}
        <Snackbar
          open={snackbar.open || somDownloading || pcDownloading || cmmDownloading || trDownloading}
          autoHideDuration={
            somDownloading || pcDownloading || cmmDownloading || trDownloading ? undefined : 4000
          }
          onClose={() => {
            if (!somDownloading && !pcDownloading && !cmmDownloading && !trDownloading) {
              setSnackbar({ ...snackbar, open: false });
            }
          }}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{
            position: "absolute",
            top: 16,
            right: 24,
          }}
        >
          <Alert
            onClose={() => {
              if (!somDownloading && !pcDownloading && !cmmDownloading && !trDownloading) {
                setSnackbar({ ...snackbar, open: false });
              }
            }}
            severity="success"
            sx={{
              width: "100%",
              backgroundColor: "#2e7d32",
              color: "#fff",

              "& .MuiAlert-icon": {
                color: "#fff",
              },

              "& .MuiAlert-action": {
                color: "#fff",
              },
            }}
          >
            {downloadStatusMessage}
          </Alert>
        </Snackbar>
        <DialogTitle>
          Valuation Schedule – {row.exam_type_name} ({row.exam_month})
        </DialogTitle>
        <DialogContent>
          <Typography variant="h6" sx={{ mt: 1, mb: 1 }}>
            {editId ? "Edit Valuation Schedule" : "Add New Valuation Schedule"}
          </Typography>
          <Grid container spacing={2}>
            {/* ... same form fields as before ... */}
            <Grid item xs={12} sm={3}>
              <TextField
                label="Valuation Type"
                name="valuation_type"
                select
                fullWidth
                value={form.valuation_type}
                onChange={(e) => setForm({ ...form, valuation_type: e.target.value })}
                SelectProps={{ native: true }}
              >
                <option value="NORMAL">NORMAL</option>
                <option value="REVALUATION">REVALUATION</option>
                <option value="RECOUNTING">RECOUNTING</option>
                <option value="CHALLENGE">CHALLENGE</option>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                label="Revaluation Round(default 0)"
                type="number"
                name="revaluation_round"
                value={form.revaluation_round}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            {Number(form.revaluation_round) !== 0 && (
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Fee Amount"
                  type="number"
                  name="fee_amount"
                  value={form.fee_amount}
                  onChange={handleChange}
                  fullWidth
                />
              </Grid>
            )}
            <Grid item xs={12} sm={3}>
              <TextField
                label="Valuation Pattern ID"
                type="number"
                name="valuation_pattern_id"
                value={form.valuation_pattern_id}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                label="Start Date"
                type="date"
                name="valuation_from_date"
                value={form.valuation_from_date}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                label="End Date"
                type="date"
                name="valuation_to_date"
                value={form.valuation_to_date}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                label="Bundle No From"
                name="bundle_no_from"
                value={form.bundle_no_from}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                label="Bundle No To"
                name="bundle_no_to"
                value={form.bundle_no_to}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                label="Script Allot Size"
                name="script_allot_size"
                value={form.script_allot_size}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                label="Workflow Status"
                name="workflow_status"
                select
                fullWidth
                value={form.workflow_status}
                onChange={(e) => setForm({ ...form, workflow_status: e.target.value })}
                SelectProps={{ native: true }}
              >
                <option value="DRAFT">DRAFT</option>
                <option value="APPROVED">APPROVED</option>
                <option value="PUBLISHED">PUBLISHED</option>
                <option value="CLOSED">CLOSED</option>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Button
                onClick={handleAddOrUpdateSchedule}
                variant="contained"
                sx={{
                  backgroundColor: "#6f8eac",
                  color: "#ffffff", // text color
                  "&:hover": {
                    backgroundColor: "#1565c0",
                    color: "#ffffff", // text color
                  },
                }}
              >
                {editId ? "Update Schedule" : "Add Schedule"}
              </Button>
            </Grid>
          </Grid>

          <Divider sx={{ mt: 3, mb: 2 }} />

          <Typography variant="h6" sx={{ mb: 1 }}>
            Existing Schedules
          </Typography>
          <Box sx={{ height: 600, width: "100%" }}>
            <DataGrid
              rows={scheduleDetails}
              columns={columns}
              getRowId={(row) => row.valuation_schedule_master_id}
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              rowsPerPageOptions={[5, 10, 25, 50]}
              pagination
              autoHeight
              disableSelectionOnClick
              disableColumnMenu
              onCellClick={(params, event) => event.stopPropagation()}
              onRowClick={(params, event) => event.stopPropagation()}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            sx={{
              backgroundColor: "red",
              color: "#ffffff",
              "&:hover": { backgroundColor: "#d32f2f" },
            }}
          >
            Close
          </Button>
        </DialogActions>
        <Backdrop
          open={processing}
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 999,
            flexDirection: "column",
          }}
        >
          <CircularProgress color="inherit" />
          <Typography sx={{ mt: 2 }}>Processing Result… Please wait</Typography>
        </Backdrop>
      </Dialog>
      {/* ShowRevaluationDialog: grid dialog for revaluation scripts allotment */}
      {/* Revaluation Dialog */}
      <ShowRevaluationDialog
        open={revaluationDialogOpen}
        row={selectedRevaluationRow}
        onClose={handleCloseRevaluationDialog}
        showSnackbar={showSnackbar}
      />
    </>
  );
};

ValuationScheduleDialog.propTypes = {
  row: PropTypes.shape({
    college_id: PropTypes.number,
    exam_schedule_master_id: PropTypes.number,
    exam_type_name: PropTypes.string,
    exam_month: PropTypes.string,
    valuation_schedule_master_id: PropTypes.number,
    valuation_type: PropTypes.string,
    revaluation_round: PropTypes.number,
    fee_amount: PropTypes.number,
    valuation_pattern_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    valuation_from_date: PropTypes.string,
    valuation_to_date: PropTypes.string,
    bundle_no_from: PropTypes.number,
    bundle_no_to: PropTypes.number,
    script_allot_size: PropTypes.number,
    workflow_status: PropTypes.string,
    semester_number: PropTypes.number,
    year_number: PropTypes.number,
  }),
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  examScheduleMasterId: PropTypes.number,
  examDate: PropTypes.string,
  programId: PropTypes.number,
  branchId: PropTypes.number,
  showSnackbar: PropTypes.func,
};

export default ValuationScheduleDialog;
